const galleryImages = [
  'https://static.readdy.ai/image/288893c5c915d12784f7c7fb5a449e01/203e112dadd9ff8b437cbab55528c185.png',
  'https://static.readdy.ai/image/288893c5c915d12784f7c7fb5a449e01/751a982c44da3203a68491bc6188de66.jpeg',
  'https://static.readdy.ai/image/288893c5c915d12784f7c7fb5a449e01/ac8c7534c23d531a35c4a7679f032bcc.png',
  'https://static.readdy.ai/image/288893c5c915d12784f7c7fb5a449e01/643265fd6eb0d811e658ed2a3fc5a791.jpeg',
  'https://static.readdy.ai/image/288893c5c915d12784f7c7fb5a449e01/0b4664e6feb624c6b6fd03332af6386e.jpeg',
  'https://static.readdy.ai/image/288893c5c915d12784f7c7fb5a449e01/c449b67467bd5c5382644c8aa2f78382.png',
  'https://static.readdy.ai/image/288893c5c915d12784f7c7fb5a449e01/bf18fd4a9344d4eeb8853af962d1ad27.png',
  'https://static.readdy.ai/image/288893c5c915d12784f7c7fb5a449e01/993a59512a151910b8f72fc0a4f122c5.png',
  'https://static.readdy.ai/image/288893c5c915d12784f7c7fb5a449e01/db86078eeea6e3d3659503164cd1e430.png',
  'https://static.readdy.ai/image/288893c5c915d12784f7c7fb5a449e01/57ff98237ef4a309ccd75a0b1e17c545.png',
  'https://static.readdy.ai/image/288893c5c915d12784f7c7fb5a449e01/a39911f70a41834567431d451335f4b6.png',
  'https://static.readdy.ai/image/288893c5c915d12784f7c7fb5a449e01/26193e8cd219a6a5bc768a22a9cfc3cd.png',
  'https://static.readdy.ai/image/288893c5c915d12784f7c7fb5a449e01/c2568adf6c51df86468b6ff6912c8db8.png',
  'https://static.readdy.ai/image/288893c5c915d12784f7c7fb5a449e01/4a4ed75b1cc9673c61ce21f392c5a6a1.png',
  'https://static.readdy.ai/image/288893c5c915d12784f7c7fb5a449e01/cf565707ba3e9e7dc3c8c7e49d4c49ec.png'
];

export default function Gallery() {
  return (
    <section id="gallery" className="py-14 md:py-20 px-4 md:px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-extrabold text-center mb-8 md:mb-12 text-gray-950">
          투명하게 공개하는,
          <br className="md:hidden" />
          <span className="text-teal-600"> 현장 사진</span>
        </h2>

        <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-5 gap-2 md:gap-4">
          {galleryImages.map((image, index) => (
            <a
              key={index}
              href="/photo"
              className="aspect-square overflow-hidden rounded-lg group cursor-pointer"
            >
              <img
                src={image}
                alt={`현장사진 ${index + 1}`}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
